import { PayloadAction } from '@reduxjs/toolkit'
import { setSettingsValue } from '../../../components/common/utility/helpers'
import { SettingsState } from '../settings.slice'

export const toggleSideNavReducer = (
    state: SettingsState,
    action: PayloadAction<boolean>
): void => {
    const { payload } = action
    state.sideNav.toggled = payload

    setSettingsValue('sideNavTpggled', payload || false)
}
